import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/shadcn/accordion';
import { Translate } from '@/components/common/Translate/Translate';

const faqData = [
    {
        question:  <Translate keyName= "question-1" /> ,
        answer: <Translate keyName="answer-1"/>
    },
    {
        question: <Translate keyName= "question-2"/>,
        answer: <Translate keyName="answer-2"/>
    },
    {
        question:  <Translate keyName= "question-3" /> ,
        answer: <Translate keyName="answer-3"/>
    },
    {
        question:  <Translate keyName= "question-4" /> ,
        answer: <Translate keyName="answer-4"/>
    },
    {
        question:  <Translate keyName= "question-5" /> ,
        answer: <Translate keyName="answer-5"/>
    },
    {
        question:  <Translate keyName= "question-1" /> ,
        answer: <Translate keyName="answer-1"/>
    },
    {
        question:  <Translate keyName= "question-6" /> ,
        answer: <Translate keyName="answer-6"/>
    },
    {
        question:  <Translate keyName= "question-7" /> ,
        answer: <Translate keyName="answer-7"/>
    },
    {
        question:  <Translate keyName= "question-8" /> ,
        answer: <Translate keyName="answer-8"/>
    },
    {
        question:  <Translate keyName= "question-9" /> ,
        answer: <Translate keyName="answer-9"/>
    },
    {
        question:  <Translate keyName= "question-10" /> ,
        answer: <Translate keyName="answer-10"/>
    },
    {
        question:  <Translate keyName= "question-11" /> ,
        answer: <Translate keyName="answer-11"/>
    },
    {
        question:  <Translate keyName= "question-12" /> ,
        answer: <Translate keyName="answer-12"/>
    },
    {
        question:  <Translate keyName= "question-13" /> ,
        answer: <Translate keyName="answer-13"/>
    },
    {
        question:  <Translate keyName= "question-14" /> ,
        answer: <Translate keyName="answer-14"/>
    },
    {
        question:  <Translate keyName= "question-15" /> ,
        answer: <Translate keyName="answer-15"/>
    },
    {
        question:  <Translate keyName= "question-16" /> ,
        answer: <Translate keyName="answer-16"/>
    },
];

export const FaqPricing = () => {
    return (
        <div className="max-w-[1200px] mx-auto md:px-36 mt-24 md:mt-16">
            <div className="text-center">
                <h2 className="text-2xl font-bold"> <Translate keyName="frequently-asked-questions"/></h2>
                <p className="mt-2"><Translate keyName="sub-title-for-faq"/></p>
            </div>

            <div className="mt-16">
                <Accordion type="single" collapsible>
                {faqData.map((faq, index) => (
    <AccordionItem 
        key={index} 
        value={`item-${index}`}
        className={`pb-7 ${index === faqData.length - 1 ? 'border-0' : ''}`}
    >
        <AccordionTrigger className="hover:no-underline items-start">
            <h3 className="text-xl font-semibold text-start flex items-center">
                {index + 1}.&nbsp;{faq.question}
            </h3>
        </AccordionTrigger>
        <AccordionContent className="pb-1">
            <p className="pt-2 text-base">
                {faq.answer}
            </p>
        </AccordionContent>
    </AccordionItem>
))}
                </Accordion>
            </div>
        </div>
    );
};